// This module controls the loading and caching of redemptions for the Redemptions page/table
// Modeled heavily off points/leaderboard.js
import Network from 'lib/api/network';

const collectionKey = ({ startDate, endDate }) => `${startDate}-${endDate}`;

export default {
  namespaced: true,

  state() {
    return {
      isFetching: false,
      startDate: null,
      endDate: null,
      redemptions: {},
      asyncValuesByRedemption: {},
    };
  },

  getters: {
    currentRedemptionCollection(state) {
      return state.redemptions[collectionKey(state)];
    },
  },

  mutations: {
    addRedemptions(state, { list, nextPage }) {
      const key = collectionKey(state);
      if (state.redemptions[key]) {
        state.redemptions[key].nextPage = nextPage;
        state.redemptions[key].list = state.redemptions[key].list.concat(list);
      } else {
        state.redemptions[key] = { nextPage, list, key };
      }
    },

    updateAsyncValuesForRedemption(state, { id, key, value }) {
      if (!state.asyncValuesByRedemption[id]) state.asyncValuesByRedemption[id] = {};
      state.asyncValuesByRedemption[id][key] = value;
    },
  },

  actions: {
    fetchRedemptions({ state, commit, dispatch }, { page }) {
      commit('update', { module: 'rewardsRedemptions', key: 'isFetching', value: true }, { root: true });
      return new Promise((resolve) => {
        let url = `/rewards/redemptions/list?page=${page}`;
        if (state.startDate) url += `&start_date=${state.startDate}`;
        if (state.endDate) url += `&end_date=${state.endDate}`;
        Network.get(url, {
          success: ({ list, nextPage }) => {
            commit('addRedemptions', { list, nextPage });
            resolve();
          },
          error: () => {
            dispatch('setErrorToast', null, { root: true });
          },
          complete: () => { commit('update', { module: 'rewardsRedemptions', key: 'isFetching', value: false }, { root: true }); },
        });
      });
    },

    updateDateRange({ getters, commit }, { startDate, endDate, fetchFirstPage }) {
      commit('update', { module: 'rewardsRedemptions', key: 'startDate', value: startDate }, { root: true });
      commit('update', { module: 'rewardsRedemptions', key: 'endDate', value: endDate }, { root: true });
      if (!getters.currentRedemptionCollection) fetchFirstPage();
    },

    fulfill({ commit, dispatch }, { redemptionId }) {
      return new Promise((resolve, reject) => {
        Network.post(`/rewards/redemptions/${redemptionId}/fulfill`, {}, {
          success: ({ redemption }) => {
            commit('updateAsyncValuesForRedemption', { id: redemption.id, key: 'fulfiller', value: redemption.fulfiller });
            commit('updateAsyncValuesForRedemption', { id: redemption.id, key: 'fulfilled_at', value: redemption.fulfilled_at });
            resolve();
          },
          error: () => {
            dispatch('setErrorToast', null, { root: true });
            reject();
          },
        });
      });
    },
  },
};
